import RoleLinks from '..'

export default RoleLinks
